export default "__VITE_PUBLIC_ASSET__6df4dd0f__"